/* eslint-disable */
import { gsap } from "gsap/all";

const $socialBtn = document.getElementById('socialBtn');
const $closeSocialOverlay = document.getElementById('closeSocialOverlay');
const $socialScreenMobile = document.getElementById('socialScreenMobile');
const $socialLinks = document.getElementsByClassName('social-mob-link');


if(window.innerWidth < 769){
  if($socialBtn) {
    $socialBtn.addEventListener('click', () => {

      gsap.set($socialScreenMobile , { zIndex: 10, opacity:1 } );

      const tlSocialIn = gsap.timeline({ ease: 'power4.inOut' })
      .fromTo( $socialScreenMobile ,  {  y: '-100%' } , {y: 0 , duration: 0.4 } )
      .fromTo( $socialLinks , { opacity:0 }, { stagger: 0.08 , opacity: 1 , duration: 0.5 } , '-=0.15' )

    });

    $closeSocialOverlay.addEventListener('click', () => {
      // tlSocial.reverse();

      const tlSocialOut = gsap.timeline({ })
      .to( $socialLinks , 0.3 ,  { stagger: 0.05 , opacity: 0 } )
      .to( $socialScreenMobile , 0.35 ,  {  y: '-100%' } , '-=0.15' )
      gsap.set($socialScreenMobile , { zIndex: -99, opacity:0, delay: 0.7 } );
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/js/header.js